import { z } from 'zod';
/**
 * Shared pagination query schema — used by files/sharedWithMe and notes/sharedWithMe.
 */
export const paginationQuerySchema = z.object({
    page: z.coerce.number().int().positive().optional().default(1),
    perPage: z.coerce.number().int().min(1).max(100).optional().default(20),
});
//# sourceMappingURL=pagination.schema.js.map